import { spacing, color } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import { eyebrow } from "../../typography/elements.js";
import "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
const invalid = {
  border: `1px solid ${color.redDark}`,
  "&[aria-errormessage] + [id]": {
    ...eyebrow,
    color: color.redDark,
    display: "block",
    margin: 0,
    marginTop: spacing.xs
  }
};
const valid = {
  border: `1px solid ${color.green}`,
  "& + [id]": {
    display: "none"
  }
};
export {
  invalid,
  valid
};
//# sourceMappingURL=_state.js.map
